//现金分红 红利再投  //因为列表里的数据完全满足了分红的需求并且从详情里面取会特别麻烦所以数据是从列表带的
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createForm } from 'rc-form';
import Util from '../../util.js';
import NHeader from "../NHeaderjiaoyijilu";
import NavigatorMain from '../NavigatorMain';
import { Picker, List, WhiteSpace, ListView } from 'antd-mobile/lib';
import '../css/Transferrecord.css'
import { hashHistory } from "react-router";
class Dividendreinvestedincash extends Component {  
  constructor(props) {  
    super(props); 
    this.state = {
      loadingFlag: false,
        xinxi:[]
    } 
  }

  goBack() {
    hashHistory.goBack();
  }
  getNum=(num1,num2)=>{
    if(num1 === null && num2 === null){
      return null
    }else if(num1 === null){
      return num2 + '份'
    }else if(num2 === null){
      return num1 + '元'
    }else if(num1 == num2){
      return num1 + '元'
    }else{
      return null
    }
  }
    // 去除时间的时分秒
    timeFormat(date){
      let newDate=/\d{4}-\d{1,2}-\d{1,2}/g.exec(date)
      return newDate[0]
    }
  render() {
      let {dividendMethod,confirmVolume,confirmAmount,trustChannelName,fundName,superFundName,confirmTimeStr}=this.props.location.state
      console.log(confirmVolume)
      return (  
        <div className="container">  
            <div className="NHeader_container">
        <div className="NHeader_wrap">         
          <div className="NHeader_content">
            <div className="NHeader_goback" onClick={this.goBack}><img src={require('../../img/n_icon_goback@2x.png')} /></div>
            <div className="NHeader_title">交易详情</div>
            <div className="NHeader_share">
            </div>
          </div>
        </div>
        </div>
   
          <div className="jiaoyixiangqing"> 
          <div className="jiaouyixiangqingtopfenhong">
          <div className="jiaouyixiangqingtop2">
            <div className="jiaouyixiangqingtop2top">分红份额</div>
            {
                     dividendMethod === "0" ?
                     <div className="jiaouyixiangqingtop2top">
                        <text style={{color:"#333333"}}>{confirmVolume ? Util.thousandCount(confirmVolume) + "份":"--"}</text>
                      </div>
                     :
                     <div className="jiaouyixiangqingtop2top">
                       <text style={{color:"#333333"}}>{confirmAmount ? Util.thousandCount(confirmAmount) + "元":"--"}</text>
                     </div>
                   }
          </div>
          <div className="jiaouyixiangqingtop2">
            <div  className="jiaouyixiangqingtop2top">分红产品</div>
            <div  className="jiaouyixiangqingtop2bottom">{fundName ? fundName:"--"}</div>
          </div>
          <div className="jiaouyixiangqingtop2">
            <div  className="jiaouyixiangqingtop2top">分红时间</div>
            <div  className="jiaouyixiangqingtop2bottom">{confirmTimeStr ? confirmTimeStr:"--"}</div>
          </div>
          <div className="jiaouyixiangqingtop2">
            <div  className="jiaouyixiangqingtop2top">分红方式</div>
            {
                       dividendMethod === "0" ?
                     <text  style={{color:"#333333"}}>红利再投</text>
                     :
                     <div className="jiaouyixiangqingtop2top">
                       {dividendMethod === "1" ?
                     <text  style={{color:"#333333"}}>现金分红</text>
                     :
                     <text  style={{color:"#333333"}}>{"--"}</text>
                      }
                     </div>

                     }
          </div>
          <div className="jiaouyixiangqingtop2">
            <div  className="jiaouyixiangqingtop2top">所属投顾产品</div>
            <text  style={{color:"#333333"}}>{superFundName ? superFundName:"--" }</text>
          </div>
          <div className="jiaouyixiangqingtop2">
            <div  className="jiaouyixiangqingtop2top">支付渠道</div>
            <text  style={{color:"#333333"}}>{trustChannelName ? trustChannelName:"--"}</text>
          </div>
         </div>
         </div>
        </div>
    
    )
  }  
}  
  
function mapStateToProps(state, ownProps) {
  return {
    shareToInfo:state.shareToInfo,
  }
}
export default connect(mapStateToProps)(Dividendreinvestedincash);



// WEBPACK FOOTER //
// ./src/components/fundDetail/Dividendreinvestedincash.js